<template>
  <Content id="WeixinLoginUser">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="openid" :label-width="50"><Input v-model="search.openid" style="width: 250px;"/></FormItem></Col>
          <Col><FormItem label="unionid" :label-width="70"><Input v-model="search.unionid" style="width: 250px;"/></FormItem></Col>
          <Col><FormItem label="手机号码" :label-width="70"><Input v-model="search.mobile" style="width: 250px;"/></FormItem></Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.sources" style="width: 100%;" :clearable="true">
                <Option v-for="item in sourcesList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width: 100%;" :clearable="true">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">
      <el-table-column fixed align="center" prop="openid" label="openid" min-width="230"/>
      <el-table-column fixed align="center" prop="unionid" label="unionid" min-width="260"/>
      <el-table-column align="center" prop="nickname" label="昵称" min-width="100"/>
      <el-table-column align="center" prop="headimgUrl" label="头像" min-width="200">
        <template slot-scope="{row}"><img :src="row.headimgUrl" style="height: 60px;width: 60px" v-if="row.headimgUrl"/></template>
      </el-table-column>
      <el-table-column align="center" prop="mobile" label="手机号码" min-width="200"/>
      <el-table-column align="center" prop="sources" label="来源" min-width="100">
        <template slot-scope="{row}">{{ row.sources == 1 ? '小程序' : row.sources == 2 ? '扫码登录' : '' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="remark" label="备注" min-width="130"/>
      <el-table-column align="center" prop="updateTime" label="更新时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="60" id="elPopoverVisible">
        <template slot-scope="{row}">
          <a @click.stop="handleEdit(row)">编辑</a>&nbsp;
          <!--
          <el-popover placement="top" min-width="150" v-model="deleteVisible['visible_' + row.id]">
            <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 35px; font-size: 16px; ">
              <i class="el-popconfirm__icon el-icon-info" style="color: red;"/>是否确定删除？
            </p>
            <div style="text-align: right; margin: 0;line-height: 30px;">
              <el-button size="small" type="text" @click="cancel(row)" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
              <el-button type="primary" size="small" @click="del(row)">确定</el-button>
            </div>
            <a slot="reference" style="color: #409EFF;">删除</a>
          </el-popover>
          -->
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <WeixinLoginUserEdit ref="edit" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import { _selectPages, _updateStatus, _delete} from "@/services/manage/weixinLoginUser";
import WeixinLoginUserEdit from "@/views/manage/weixinLoginUser/WeixinLoginUserEdit.vue";
export default {
  name: "WeixinLoginUser",
  components: {
    WeixinLoginUserEdit
  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        unionid: "",
        openid: "",
        mobile: "",
        status:1
      },
      deleteVisible:{},
      editWindow:false,
      windowTitle:"编辑",
      dataList: [],
      statusList:[
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      sourcesList:[
        {label: '全部', value: ''},
        {label: '小程序', value: 1},
        {label: '扫码登录', value: 2},
      ],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _selectPages({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode === 1 && res.data && res.data.records && res.data.records.length > 0) {
          res.data.records.forEach(item => {
            this.deleteVisible['visible_' + item.id] = false;
          })
        }

        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs['edit'].handleModal(row);
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.openid){
        return new Promise((resolve,reject) => {
          this.$confirm('是否确定' + (targetValue === 1 ? "启用" : "停用") + '<span style="color: red;font-weight: bold;"> ' + row.openid + ' </span>吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({openid:row.openid, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    cancel(){
      this.$nextTick(()=>{
        document.getElementById('elPopoverVisible').click();
      })
    },
    del(row) {
      _delete({id: row.id}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.handleDataList();
          this.$message.success("删除成功")
        }else{
          this.$message.error(res.errmsg)
        }
      })
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
.el-table{border: 0px solid #ccc;}
/deep/ .el-table .el-table__cell {padding: 11px 0;}

</style>
